import { useParams } from "react-router";
import CoreRuleTable from "@gf-core/widgets/widgets/CoreRuleTable";

export default function RulesTab() {
  const { installationId, deviceId } = useParams();

  if (!installationId || !deviceId) return null;

  return (
    <CoreRuleTable
      installationId={installationId}
      deviceTwinId={deviceId}
      withTiles={false}
    />
  );
}
